var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamgrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4502 5.698H1.4502C0.850195 5.698 0.450195 6.098 0.450195 6.698C0.450195 7.298 0.850195 7.698 1.4502 7.698H17.4502C18.0502 7.698 18.4502 7.298 18.4502 6.698C18.4502 6.098 18.0502 5.698 17.4502 5.698ZM1.4502 2.698H17.4502C18.0502 2.698 18.4502 2.298 18.4502 1.698C18.4502 1.098 18.0502 0.697998 17.4502 0.697998H1.4502C0.850195 0.697998 0.450195 1.098 0.450195 1.698C0.450195 2.298 0.850195 2.698 1.4502 2.698ZM17.4502 10.698H1.4502C0.850195 10.698 0.450195 11.098 0.450195 11.698C0.450195 12.298 0.850195 12.698 1.4502 12.698H17.4502C18.0502 12.698 18.4502 12.298 18.4502 11.698C18.4502 11.098 18.0502 10.698 17.4502 10.698Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamgrey);
export default __webpack_public_path__ + "static/media/hamgrey.2bd787aed0ddb24faddf2a90f7fa33e8.svg";
export { ForwardRef as ReactComponent };